import React           from 'react';
import { makeStyles }  from "makeStyles";
import compSize        from './inputCompSize';


var clsx = require('classnames')
const { rootHeight, rootWidth, gap } = compSize;


const useStyles = makeStyles()(
    (theme) => ({
    row: {
        flexFlow:       'row',
        alignItems:     'center',
        display:        'flex',
        flex:           1
    },
    unit: {
        width:           (rootWidth / 6) - gap,
        height:          (rootHeight / 2) - gap,
        marginLeft:      5,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        color:           '#FFF',
        borderRadius:    '0.5em',
        cursor:          'default',
        fontWeight:      'bold',
        backgroundColor: theme.blue,
        boxShadow:       theme.buttonShadow
    },
    transparent: {
        opacity: 0.5,
        cursor: 'default',
        '&:hover': {
            backgroundColor: theme.blue,
        }
    }
})
);

type KeyRowProps = {
    question:        number;
    pageNum:         number;
    arr:             string[];
}

const KeyRow: React.FC<KeyRowProps> = ({ 
    question,
    pageNum,
    arr,
 }) => {

 const { classes } = useStyles();


  return (
        <div className = { classes.row }>
            {
                arr.map((val, ind) => {

                    const transp = !!(((pageNum === 3 || pageNum === 4) && val === '3' ) || (pageNum === 4 && val === '7'))

                    return (
                        <div 
                          key       = { `exercises_solutions${ ind }` }
                          className = { transp ? clsx(classes.unit, classes.transparent) : classes.unit }
                         // onClick   = { () => { keyBoardClick(val) }}
                        >
                           { val }
                        </div>
                    )
                })
            }
        </div>
                   
  );
}



  export default KeyRow;
    
    
    
    






